import React, { useState } from "react";
import { alpha, IconButton, Stack } from "@mui/material";
import { blue } from "@mui/material/colors";
import { ScanBarcode } from "iconsax-react";
import GuidesQRImageDialog from "../GuidesQRImageDialog";

export default function GuidesTableActionsDelivered({ guide, fetchGuides }) {
  const [openDialog, setOpenDialog] = useState(null);

  const handleDialogOpen = (dialogName, event) => {
    event.stopPropagation();
    handleDownloadPDFClick();
    /* setOpenDialog(dialogName); */
  };

  const handleDialogClose = () => {
    setOpenDialog(null);
  };

  const handleDownloadPDFClick = () => {
    const link = document.createElement('a');
    link.href = guide.s3_qrcode;
    link.setAttribute('target', '_blank');
    link.download = 'GuíaCódigoQR.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  return (
    <Stack
      direction="row"
      spacing={0.1}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        gap: "4px",
      }}
    >
      <GuidesQRImageDialog
        open={openDialog === "QRImage"}
        onClose={() => {
          handleDialogClose();
        }}
        urlImage={guide.s3_qrcode}
      />

      <IconButton
        size="small"
        color="primary"
        aria-label="add to shopping cart"
        onClick={(event) => handleDialogOpen("QRImage", event)}
        style={{ color: blue[400], backgroundColor: alpha(blue[500], 0.1) }}
      >
        <ScanBarcode fontSize="small" />
      </IconButton>
      {/* <IconButton
        size="small"
        color="primary"
        aria-label="add to shopping cart"
        onClick={() => handleDialogOpen("Map")}
        style={{ color: blue[400], backgroundColor: alpha(blue[500], 0.1) }}
      >
        <LocationAdd fontSize="small" />
      </IconButton> */}
    </Stack>
  );
}
